/* This file is autogenerated, see readme.md for instructions */
import PersAlt3SvgIcon from '@bloomreach/banana-theme/icons/pers-alt-3.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PersAlt3Icon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PersAlt3SvgIcon />
    </Icon>
  );
});

PersAlt3Icon.displayName = 'PersAlt3Icon';

export default PersAlt3Icon;
